/**
 * @description Flags are a way to define combinations of enum-values. Usage: To store
 * XS and SM for instance we could simply write `BreakpointFlag.XS | BreakpointFag.SM`
 * @example
 * const mobile = BreakpointFlag.XS | BreakpointFlag.SM;
 * const tablet = BreakpointFlag.MD;
 * const desktop = BreakpointFlag.LG | BreakpointFlag.XL | BreakpointFlag.XXL;
 */
export enum BreakpointFlag {
  All = 0,
  XS = 1 << 0,
  SM = 1 << 1,
  MD = 1 << 2,
  LG = 1 << 3,
  XL = 1 << 4,
  XXL = 1 << 5,
}

export const TileImageBreakpoints = BreakpointFlag.XS | BreakpointFlag.SM | BreakpointFlag.XL;

export type ResponsiveImageConfig = {
  filenameKey: string;
  visibleFrom: number;
  realWidth?: number;
};

export type ResponsiveImageConfigMap = Record<BreakpointFlag, ResponsiveImageConfig>;
export type ResponsiveImageConfigOverride = Record<BreakpointFlag, Partial<ResponsiveImageConfig>>;

export type SchemalessImageMapping = Record<BreakpointFlag, string | null>;
